import React from 'react'

import { isIE, isLegacyEdge } from 'react-device-detect';
import { ReactApp } from './ReactApp';
import { IE11 } from './views/IE11';

// Internet Explorer 6-11
//@ts-ignore
const isIE1 = /*@cc_on!@*/false || !!document.documentMode;

export const App: React.FC = () => {
  console.log('IS IE', isIE, isIE1, isLegacyEdge);
  if(isIE1) {
    return <IE11 />;
  }

  return <ReactApp />;
}
